import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import { InferType } from 'yup';

import { FormikForm } from '@/components/formik/FormikForm';
import { GenericModal } from '@/components/modal/GenericModal';

import { TOnSubmit } from '@/types/formTypes';

import { stationAddPumpSchema } from '@/validation/station';

import { EditPumpFormBody } from './ModalBody/EditPumpFormBody';
import { NewPumpFormBody } from './ModalBody/NewPumpFormBody';
import { TPumpModalProps } from './types';

type TPumpModalData = InferType<typeof stationAddPumpSchema>;

export const PumpModal = ({ close, initialData, title, onSubmit }: TPumpModalProps) => {
  const { t } = useTranslation();

  const handleSubmit: TOnSubmit<TPumpModalData> = async (data) => {
    await onSubmit(data);
    close('pump.create');
  };

  const renderBody = () => {
    if (initialData) {
      return <EditPumpFormBody close={close} />;
    }
    return <NewPumpFormBody close={close} />;
  };

  return (
    <GenericModal
      sx={{
        width: 'min(80%, 480px)',
        padding: 6,
      }}
    >
      <Typography variant="h6" textAlign="center" marginBottom={3}>
        {t(title)}
      </Typography>
      <FormikForm
        initialValues={initialData}
        validationSchema={stationAddPumpSchema}
        onSubmit={handleSubmit}
      >
        {renderBody()}
      </FormikForm>
    </GenericModal>
  );
};
